module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/font-styles/font-styles.component.scss
// module id = ./src/app/shared/font-styles/font-styles.component.scss
// module chunks = main